import React from 'react';
import ReactDOM from 'react-dom/client';
import {ReactViewAdobe} from 'react-adobe-embed';
import './index.scss';
import App from './App';
import { clientId } from './Components/SecureMesage';
import {registerLicense} from '@syncfusion/ej2-base';

//@ts-ignore
registerLicense(process.env.SYNC_FUCK_TION_KEY)

console.log(process.env);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
console.log('hi');
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

